/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const relativePrioritySchema = z.object({
  id: z.int().nullish(),
  type: z.enum(['before', 'after', 'first']),
});
